export default __webpack_public_path__ + "static/media/sport-mascot.19d0f15b.png";